import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "PlanningDashboardPage" */
	'pages/intervention/Planning/PlanningDashboardPage'));

export default [{ component, exact: true, path: '/plannings/:planningId' }];